import { showFailed } from "../../../CommonFunction/SweetAlert";

export const BorrowerDashboardDetails = async (jwtToken) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/dashboard/bank/borrowerDashborad`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      showFailed(`Failed to post organization data`, `${response.statusText}`);
    }
  } catch (error) {
    showFailed("Failed to load data.", error);
  }
};

export const BorrowerNotification = async (jwtToken, page) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/user/user-notification?page=${page}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      showFailed(`Failed to post organization data`, `${response.statusText}`);
    }
  } catch (error) {
    showFailed("Failed to load data.", error);
  }
};

export const BorrowerNotificationById = async (jwtToken, id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/user/user-notification/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      showFailed(`Failed to post organization data`, `${response.statusText}`);
    }
  } catch (error) {
    showFailed("Failed to load data.", error);
  }
};
